import { useEffect } from 'react';
import { useUpdateAtom } from 'jotai/utils';
import { assetContentTypesAtom } from 'src/shared/chat';

/**
 * Records the content types of a search payload's assets in
 * `assetContentTypesAtom`, so the AI Agent knows what the user selected
 * (useChatContext) and can offer image- or video-specific starters.
 */
export function useRememberContentTypes(
  extendedResult: Record<string, { content_type?: string }> | undefined,
) {
  const setKnown = useUpdateAtom(assetContentTypesAtom);
  useEffect(() => {
    if (!extendedResult) return;
    const found: Record<string, string> = {};
    Object.entries(extendedResult).forEach(([id, asset]) => {
      if (asset?.content_type) found[id] = asset.content_type;
    });
    if (Object.keys(found).length === 0) return;
    setKnown((prev) => ({ ...prev, ...found }));
  }, [extendedResult, setKnown]);
}

export default useRememberContentTypes;
